<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">充值统计<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="选择门店" class="select-item" multiple collapse-tags collapse-tags-tooltip :max-collapse-tags="3" @change="shopChange">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-checkbox v-model="checkAll" style="margin-left: 8px;" @change="checkAllShop">全选</el-checkbox>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>


          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)">查询</ElButtons>
            </div>
<!--            <div class="content-input-btn">-->
<!--              <ElButtons icon="RefreshLeft" @click="refreshParam">重置</ElButtons>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content-main">
        <div class="content-button">
<!--          <div>-->
<!--            <el-button type="warning" @click="exportExcel">导出Excel</el-button>-->
<!--          </div>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--          </div>-->

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
<!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="shopName" label="所属门店"></el-table-column>
            <el-table-column property="newUserNum" label="新增会员"></el-table-column>
            <el-table-column property="payNumOne" label="500账户"></el-table-column>
            <el-table-column property="payNumTwo" label="1000账户"></el-table-column>
            <el-table-column property="payNumThree" label="1500账户"></el-table-column>
            <el-table-column property="payNumFour" label="2500账户"></el-table-column>
            <el-table-column property="payNumMoney" label="充值总额"></el-table-column>
            <el-table-column property="payMoney" label="充值余额"></el-table-column>
            <el-table-column property="payNumGive" label="赠送总额"></el-table-column>
            <el-table-column property="giveMoney" label="赠送余额"></el-table-column>
            <el-table-column property="allMoney" label="总余额"></el-table-column>
          </el-table>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="sumDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
            <el-table-column property="shopName" label="以上汇总"></el-table-column>
            <el-table-column property="newUserNum" label="新增会员"></el-table-column>
            <el-table-column property="payNumOne" label="500账户"></el-table-column>
            <el-table-column property="payNumTwo" label="1000账户"></el-table-column>
            <el-table-column property="payNumThree" label="1500账户"></el-table-column>
            <el-table-column property="payNumFour" label="2500账户"></el-table-column>
            <el-table-column property="payNumMoney" label="充值总额"></el-table-column>
            <el-table-column property="payMoney" label="充值余额"></el-table-column>
            <el-table-column property="payNumGive" label="赠送总额"></el-table-column>
            <el-table-column property="giveMoney" label="赠送余额"></el-table-column>
            <el-table-column property="allMoney" label="总余额"></el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {getShopWalletStatList, exportShopRepurchaseExcel, getConsumeStatSummary} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import DatePickerRange from "@/components/DatePickerRange_2020";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import { decimal_NUM, add } from "@/assets/shared/util";
import unLock from "@/layout/components/unLock";
// import pageDesc from "@/components/pageDesc";


export default {
  name: "StatWallet",
  components: { DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [],
      shopIdArr:[],
      shopId: [],
      checkAll: true,

      indeterminate: true,


      //刷新组
      colList: ['所属门店', '新增会员', '充值余额', '赠送余额', '总余额'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '称呼', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //抵扣时间
      startDeductionTime: '',
      endDeductionTime: '',
      isDeductionChecked: true,

      idArray: [],
      sort: 1,

      upChargeLoading: false,


    }
  },
  methods: {



    // handleCheckAll(val) {
    //   this.indeterminate = false
    //   if(val) {
    //     this.shopIdArray.map(item => {
    //       this.shopId.push(item.id)
    //     })
    //   }else {
    //     this.shopId = []
    //   }
    // },

    checkAllShop(val) {
      this.shopId = []
      if(val) {
        this.shopIdArray.map(item => {
          this.shopId.push(item.id)
        })
        this.getPage()
      }
    },

    shopChange() {
      if(this.shopId.length == this.shopIdArray.length) {
        this.checkAll = true
      }else {
        this.checkAll = false
      }
      this.getPage()
    },


    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isDeductionChecked = true;
      this.sex = -1;
      this.shopId = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    // //获取选中id
    // selsChange(sels) {
    //   this.idArray = sels.map(item => item.userId);
    // },
    //
    // //全选
    // selsAll(column, event) {
    //   if(column.type == 'selection') {
    //     let array = this.idArray;
    //     if(array.length == this.pageDataList.length) {
    //       array = [];
    //     }
    //     this.pageDataList.forEach(item => {
    //       if(array.indexOf(item.userId) === -1) {
    //         this.$refs.multipleTableRef.toggleRowSelection(item);
    //       }
    //     })
    //   }
    // },


    getPage(reset) {
      if(!this.checkAll && this.shopId.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请先选择门店',
          type: 'warning'
        })
        return false
      }
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      // let ids = []
      // if(this.checkAll) {
      //   this.shopIdArray.map(item => {
      //     ids.push(item.id)
      //   })
      // }else {
      //   ids = this.shopId
      // }
      param['shopIds'] = this.shopId.toString();
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopWalletStatList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
          let sumObj = {
            newUserNum: 0,
            payNumOne: 0,
            payNumTwo: 0,
            payNumThree: 0,
            payNumFour: 0,
            payNumMoney: 0,
            payMoney: 0,
            payNumGive: 0,
            giveMoney: 0,
            allMoney: 0,
          }
          this.pageDataList.map(item => {
            item.payNumMoney = add([item.payNumOne, item.payNumTwo, item.payNumThree, item.payNumFour])
            item.allMoney = add([item.payMoney, item.giveMoney])
            sumObj.newUserNum = add([sumObj.newUserNum, item.newUserNum])
            sumObj.payNumOne = add([sumObj.payNumOne, item.payNumOne])
            sumObj.payNumTwo = add([sumObj.payNumTwo, item.payNumTwo])
            sumObj.payNumThree = add([sumObj.payNumThree, item.payNumThree])
            sumObj.payNumFour = add([sumObj.payNumFour, item.payNumFour])
            sumObj.payNumMoney = add([sumObj.payNumMoney, item.payNumMoney])
            sumObj.payMoney = add([sumObj.payMoney, item.payMoney])
            sumObj.payNumGive = add([sumObj.payNumGive, item.payNumGive])
            sumObj.giveMoney = add([sumObj.giveMoney, item.giveMoney])
            sumObj.allMoney = add([sumObj.allMoney, item.allMoney])
          })
          this.sumDataList = []
          this.sumDataList.push(sumObj)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },




    toggleSelection(row, column, cell, event) {

      // if(column.type == 'selection') {
      //   this.$refs.multipleTableRef.toggleRowSelection(row)
      // }

    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: e,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(s => s.openState == 1)
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    if(JSON.parse(sessionStorage.getItem('isSuper')) == 1){
      this.shopIdArray.push({name:'整体', id:0})
    }
    this.shopIdArray.map(item => {
      this.shopId.push(item.id)
    })
    this.getPage();

  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
